 
/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Formik, Field, Form } from "formik";
import { connect, useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";
import { Input } from "../../../../_metronic/_partials/controls";
import * as actions from "../../../../store/actions/index";
import { compose } from "redux";
import * as Yup from "yup";
import { FormGroup, Alert, Spinner } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import { toastifyConstant } from "../../../../helpers";
// import { loadReCaptcha } from "react-recaptcha-v3";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import { getPublicRecaptcha } from "../../../../store/actions/index";
import { onPasteHelper } from "../../../../helpers/onPasteHelper";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import OtpInput from "react-otp-input";
import { Modal, Button } from "react-bootstrap";
import FloatingInput from "../../../components/common/FloatingInput/FloatingInput";
import "./AuthLayout.scss";

const initialValues = {
  email: "",
  password: "",
  user_captcha_input: "",
};

let validationSchema = {};

function Login(props) {
  const { loading } = useSelector((state) => state.auth);
  const [showPassword, setShowPassword] = useState(false);
  const adminLoginStatus = props?.recaptcha?.adminLoginStatus;
  const [show, setShow] = useState(false);
  const [otp, setOtp] = useState("");
  const [disableButton, setDisableButton] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (props.enableTwoFactorAuth) {
      setShow(true);
      setOtp();
      setDisableButton(true);
      setIsLoading(false);
    }
  }, [props.enableTwoFactorAuth]);

  useEffect(() => {
    if (props.twoFactorAuthError) {
      setIsLoading(false);
    }
  }, [props.twoFactorAuthError]);

  useEffect(() => {
    if (adminLoginStatus) {
      loadCaptchaEnginge(6, "#dcebff");
    }
  }, [adminLoginStatus]);

  if (adminLoginStatus) {
    initialValues.user_captcha_input = "";
    validationSchema = Yup.object().shape({
      email: Yup.string()
        .matches(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          "Enter email in valid format"
        )
        .required("Email is required"),
      password: Yup.string().required("Password is required"),
      user_captcha_input: Yup.string().required("Captcha is required"),
    });
  } else {
    validationSchema = Yup.object().shape({
      email: Yup.string()
        .matches(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          "Enter email in valid format"
        )
        .required("Email is required"),
      password: Yup.string().required("Password is required"),
    });
  }

  useEffect(() => {
    props.onGetPublicRecaptcha();
  }, []);

  const handleChange = (otp) => {
    props.onClearTwoFactorError();
    setOtp(otp);
    if (otp.length === 6) {
      setDisableButton(false);
      props.onVerifyMFA(props.enableTwoFactorAuth.email, otp);
      setIsLoading(true);
    } else {
      setDisableButton(true);
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    props.onClearTwoFactorData();
    props.onClearTwoFactorError();
    setShow(false);
    setOtp("");
    setDisableButton(true);
  };

  const clearOtp = () => {
    props.onClearTwoFactorError();
    setOtp("");
    setDisableButton(true);
    setIsLoading(false);
  };

  const handleVerify = () => {
    props.onVerifyMFA(props.enableTwoFactorAuth.email, otp);
  };

  const [showingAlert, setShowingAlert] = useState(false);

  const getInputClasses = (meta, fieldname) => {
    let result = "form-control form-control-solid h-auto py-5 px-6 ";
    if (meta.touched && meta.error) {
      result += " is-invalid";
    }

    if (meta.touched && !meta.error) {
      result += " is-valid";
    }

    return result;
  };
  let errorMessage = "";
  let authRedirect = "";
  if (props?.error) {
    errorMessage = (
      <Alert
        variant="danger"
        onClose={() => setShowingAlert(false)}
        dismissible>
        {props?.error?.message}
      </Alert>
    );
  }
  const { generalSettings } = useSelector((state) => state.settings);
  return (
    <div className="login-wrapper px-4 px-lg-10">
      <div className="login-form-section bg-white py-10 px-8">
        <ToastContainer />
        {/* begin::Head */}
        {authRedirect}
        <div className="mb-8">
          <div className="d-flex align-items-center gap-3 text-dark font-size-h3 fw-bolder">
            <p className="svg-icon d-inline-block m-0 mb-2 menu-icon">
              <SVG src={toAbsoluteUrl("media/svg/icons/General/secured.svg")} />
            </p>
            <FormattedMessage id="AUTH.LOGIN.TITLE" />
          </div>
          <p className="text-dark font-size-base">
            Welcome to {generalSettings?.siteName}!
          </p>
        </div>
        {errorMessage}

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(fields) => {
            if (adminLoginStatus) {
              let user_captcha_value = fields.user_captcha_input;
              if (validateCaptcha(user_captcha_value) === true) {
                props.onAuth(fields.email, fields.password);
                window.scrollTo({ top: 0, behavior: "smooth" });
                loadCaptchaEnginge(6);
              } else {
                toast.error("Please Enter Valid Captcha", {
                  toastifyConstant,
                  toastId: "error",
                });
              }
            } else {
              props.onAuth(fields.email, fields.password);
            }
          }}>
          {({ isValid, dirty, setFieldValue, validateForm, isSubmitting }) => (
            <Form className="form">
              <FormGroup className="mb-6 position-relative">
                <span
                  style={{ top: "15px" }}
                  className="svg-icon position-absolute z-2 ps-3 menu-icon">
                  <SVG
                    src={toAbsoluteUrl("media/svg/icons/General/Message.svg")}
                  />
                </span>
                <Field name="email">
                  {({ field, meta }) => (
                    <FloatingInput
                      {...field}
                      type="text"
                      label="Email"
                      required={true}
                      className="ps-10"
                      labelClassName="ps-7"
                      error={
                        meta.touched && meta.error ? meta.error : undefined
                      }
                      onPaste={(e) => {
                        const pastedValue = e.clipboardData
                          .getData("text")
                          .trim();
                        form.setFieldValue("email", pastedValue, true);
                        form.setFieldTouched("email", true, false);
                      }}
                      onBlur={(e) => {
                        setFieldValue("email", e.target.value.trim());
                        validateForm();
                      }}
                    />
                  )}
                </Field>
              </FormGroup>

              <FormGroup className="mb-6 position-relative">
                <span
                  style={{ top: "15px" }}
                  className="svg-icon position-absolute z-2 ps-3 menu-icon">
                  <SVG
                    src={toAbsoluteUrl("media/svg/icons/General/Lock2.svg")}
                  />
                </span>

                <Field name="password">
                  {({ field, meta }) => (
                    <>
                      <FloatingInput
                        {...field}
                        maxLength="20"
                        type={showPassword ? "text" : "password"}
                        label="Password"
                        required={true}
                        className="ps-10"
                        labelClassName="ps-7"
                        error={
                          meta.touched && meta.error ? meta.error : undefined
                        }
                        onPaste={(e) => {
                          const pastedValue = e.clipboardData
                            .getData("text")
                            .trim();
                          form.setFieldValue("password", pastedValue, true);
                          form.setFieldTouched("password", true, false);
                        }}
                        onBlur={(e) => {
                          setFieldValue("password", e.target.value.trim());
                          validateForm();
                        }}
                      />
                      <span
                        style={{ top: "15px", cursor: "pointer" }}
                        onClick={() => setShowPassword(!showPassword)}
                        className={`position-absolute z-2 end-0 ${
                          meta.touched && meta.error ? "pe-10" : "pe-3"
                        } `}>
                        {showPassword ? (
                          <SVG
                            src={toAbsoluteUrl(
                              "media/svg/icons/General/eye.svg"
                            )}
                          />
                        ) : (
                          <SVG
                            src={toAbsoluteUrl(
                              "media/svg/icons/General/hide.svg"
                            )}
                          />
                        )}
                      </span>
                    </>
                  )}
                </Field>
              </FormGroup>
              {adminLoginStatus ? (
                <FormGroup className="mb-3">
                  <LoadCanvasTemplateNoReload />
                  <Field
                    name="user_captcha_input"
                    id="user_captcha_input"
                    component={Input}
                    placeholder="Enter captcha"
                    label="Captcha">
                    {({ field, form, meta }) => (
                      <div>
                        <input
                          maxLength="20"
                          type="text"
                          {...field}
                          className={`${getInputClasses(meta)}`}
                          placeholder="Enter Captcha"
                        />
                        {meta.touched && meta.error && (
                          <div className="error invalid-feedback">
                            {meta.error}
                          </div>
                        )}
                      </div>
                    )}
                  </Field>
                </FormGroup>
              ) : null}
              {/* begin::Actions */}
              <div className="form-group d-flex flex-wrap justify-content-between align-items-right">
                <div className="text-dark-50 text-hover-primary my-3 mr-2"></div>
                {/* <Link
                to="/auth/forgot-password"
                className="text-dark-50 text-hover-primary my-3 me-2"
                id="loginForgotPassword">
                <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" />
              </Link> */}

                <button
                  id="loginSubmit"
                  type="submit"
                  disabled={!isValid}
                  className={`btn btn-primary w-100 rounded-fix fw-bold border-0 px-9 py-2`}>
                  {loading ? (
                    <Spinner
                      variant="light"
                      style={{ height: "1.2rem", width: "1.2rem" }}
                    />
                  ) : (
                    "Log In"
                  )}
                </button>
              </div>
              {/* end::Actions */}
            </Form>
          )}
        </Formik>
        {/*end::Form*/}
      </div>
      <ul className="p-0 text-primary font-size-xs d-flex text-dark user-select-none flex-row justify-content-center align-items-center mt-5">
        <li className="list-unstyled p-0 border-bottom border-dark">
          Terms & Conditions
        </li>
        <li className="border-bottom border-dark ms-6">Legal Notice</li>
      </ul>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Body className="text-black">
          {props.twoFactorAuthError ? (
            <Alert variant="danger">{props.twoFactorAuthError}</Alert>
          ) : null}

          <div className="d-flex justify-content-between align-items-center mb-7">
            <Modal.Title style={{ fontSize: "24px" }}>Verify 2FA</Modal.Title>
            <Button
              variant="dark"
              size="sm"
              onClick={handleClose}
              className="px-3 py-1"
              style={{ borderRadius: "12px" }}>
              Close
            </Button>
          </div>
          <p>
            1. Download and install an app Google Authenticator on your mobile
            device.{" "}
            <a
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
              className="mr-3 text-secondary"
              target="_blank"
              rel="noreferrer">
              Goole Playstore
            </a>
            <span> and </span>
            <a
              href="https://apps.apple.com/us/app/google-authenticator/id388497605"
              target="_blank"
              className="text-secondary"
              rel="noreferrer">
              App store
            </a>
          </p>
          {props.enableTwoFactorAuth?.twoFactorAuthVerified === "no" && (
            <>
              <p>2. Scan the QR code.</p>
              <div className="d-flex justify-content-center mb-3">
                <img
                  src={props.enableTwoFactorAuth?.image}
                  width={"200px"}
                  alt="QR Code"
                />
              </div>
            </>
          )}
          <p>
            {props.enableTwoFactorAuth?.twoFactorAuthVerified === "no"
              ? "3"
              : "2"}{" "}
            Enter and verify the authentication code generated by the app.
          </p>

          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex w-100 justify-content-center flex-wrap flex-sm-nowrap gap-5 gap-sm-0 align-items-center mt-3">
              <OtpInput
                value={otp}
                inputStyle={{
                  width: "2.5rem",
                  height: "3.2rem",
                  margin: "0 0.5rem",
                  fontSize: "1.5rem",
                  borderRadius: "10px",
                  border: "1px solid #0093ff",
                  textAlign: "center",
                }}
                onChange={(e) => handleChange(e)}
                numInputs={6}
                inputType="tel"
                renderSeparator={<span>-</span>}
                renderInput={(props) => <input {...props} />}
              />
              <Button
                variant="light"
                className="py-1 text-black rounded-4 font-size-sm fw-medium"
                onClick={() => clearOtp()}>
                Clear
              </Button>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-end mt-8">
            <div className="d-flex gap-5">
              <Button
                variant="outline"
                className="text-text-clr fw-medium py-2"
                onClick={() => handleClose()}>
                Cancel
              </Button>

              <Button
                variant="primary"
                className="py-2 px-8"
                onClick={() => handleVerify()}
                disabled={disableButton}>
                {isLoading ? "Wait..." : "Verify"}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthorized: state.auth.token,
    recaptcha: state.recaptcha.publicRecaptcha,
    enableTwoFactorAuth: state.auth.enableTwoFactorAuth,
    twoFactorAuthError: state.auth.twoFactorAuthError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAuth: (email, password) => {
      dispatch(actions.auth(email, password));
      dispatch(actions.getTaxomony());
    },
    onGetPublicRecaptcha: () => dispatch(getPublicRecaptcha()),
    onVerifyMFA: (email, mfaCode) =>
      dispatch(actions.verifyMFA(email, mfaCode)),
    onClearTwoFactorData: () => dispatch(actions.clearTwoFactorLoginData()),
    onClearTwoFactorError: () => dispatch(actions.clearTwoFactorLoginError()),
  };
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Login);
